<list-view *ngIf="listeEtats" [liste]="listeEtats"></list-view>